function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M5.84863 27.5L14.7637 17.7358M26.226 5L17.7354 14.2045",
  stroke: "white",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "bevel"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M5 5L22.4057 27.5H27.5L10.5189 5H5Z",
  stroke: "white",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/social-twitter.e0200875.svg";
export { SvgComponent as ReactComponent };